var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeambg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1924,
    height: 1454,
    viewBox: "0 0 1924 1454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(0 -6477)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 1924,
    height: 1454,
    transform: "translate(0 6477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(-3122 1119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-721 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-2",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-2",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-2",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-2",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-2",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-3",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-3",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-3",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-3",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-3",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-2",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-4",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-4",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-4",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-4",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-4",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-2",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-3",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-5",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-5",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-5",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-5",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-5",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-3",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-6",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-6",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-6",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-6",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-6",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-2",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-4",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-7",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-7",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-7",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-7",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-7",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-4",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-8",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-8",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-8",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-8",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-8",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-2",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-3",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-5",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-9",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-9",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-9",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-9",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-9",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-5",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-10",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-10",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-10",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-10",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-10",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-3",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-6",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-11",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-11",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-11",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-11",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-11",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-6",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-12",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-12",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-12",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-12",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-12",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-2",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-4",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-7",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-13",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-13",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-13",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-13",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-13",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-7",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-14",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-14",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-14",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-14",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-14",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-4",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-8",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-15",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-15",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-15",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-15",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-15",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-8",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-16",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-16",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-16",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-16",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-16",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(-801 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161-2",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-3",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-5",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-9",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-17",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-17",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-17",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-17",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-17",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-9",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-18",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-18",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-18",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-18",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-18",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-5",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-10",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-19",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-19",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-19",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-19",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-10",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-20",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-20",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-20",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-20",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-20",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-3",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-6",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-11",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-21",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-21",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-21",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-21",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-21",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-11",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-22",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-22",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-22",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-22",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-22",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-6",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-12",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-23",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-23",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-23",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-23",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-23",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-12",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-24",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-24",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-24",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-24",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-24",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162-2",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-4",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-7",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-13",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-25",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-25",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-25",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-25",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-25",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-13",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-26",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-26",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-26",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-26",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-26",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-7",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-14",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-27",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-27",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-27",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-27",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-27",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-14",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-28",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-28",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-28",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-28",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-28",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-4",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-8",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-15",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-29",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-29",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-29",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-29",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-29",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-15",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-30",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-30",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-30",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-30",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-30",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-8",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-16",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-31",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-31",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-31",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-31",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-31",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-16",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-32",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-32",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-32",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-32",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-32",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(6101 2095) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202-2",
    "data-name": "Group 202",
    transform: "translate(-721 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161-3",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-5",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-9",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-17",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-33",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-33",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-33",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-33",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-33",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-17",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-34",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-34",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-34",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-34",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-34",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-9",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-18",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-35",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-35",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-35",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-35",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-35",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-18",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-36",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-36",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-36",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-36",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-36",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-5",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-10",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-19",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-37",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-37",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-37",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-37",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-37",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-19",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-38",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-38",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-38",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-38",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-38",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-10",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-20",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-39",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-39",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-39",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-39",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-39",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-20",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-40",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-40",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-40",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-40",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-40",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162-3",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-6",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-11",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-21",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-41",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-41",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-41",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-41",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-41",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-21",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-42",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-42",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-42",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-42",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-42",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-11",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-22",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-43",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-43",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-43",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-43",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-43",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-22",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-44",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-44",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-44",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-44",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-44",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-6",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-12",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-23",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-45",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-45",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-45",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-45",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-45",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-23",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-46",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-46",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-46",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-46",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-46",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-12",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-24",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-47",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-47",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-47",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-47",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-47",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-24",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-48",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-48",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-48",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-48",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-48",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203-2",
    "data-name": "Group 203",
    transform: "translate(-801 4108)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161-4",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-7",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-13",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-25",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-49",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-49",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-49",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-49",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-49",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-25",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-50",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-50",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-50",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-50",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-50",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-13",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-26",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-51",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-51",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-51",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-51",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-51",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-26",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-52",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-52",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-52",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-52",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-52",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-7",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-14",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-27",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-53",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-53",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-53",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-53",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-53",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-27",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-54",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-54",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-54",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-54",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-54",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-14",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-28",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-55",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-55",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-55",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-55",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-55",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-28",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-56",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-56",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-56",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-56",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-56",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162-4",
    "data-name": "Group 162",
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159-8",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-15",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-29",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-57",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-57",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-57",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-57",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-57",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-29",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-58",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-58",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-58",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-58",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-58",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-15",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-30",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-59",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-59",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-59",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-59",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-59",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-30",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-60",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-60",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-60",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-60",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-60",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160-8",
    "data-name": "Group 160",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157-16",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-31",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-61",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-61",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-61",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-61",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-61",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-31",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-62",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-62",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-62",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-62",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-62",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158-16",
    "data-name": "Group 158",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155-32",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-63",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-63",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-63",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-63",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-63",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156-32",
    "data-name": "Group 156",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-64",
    "data-name": "Ellipse 16",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5480 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17-64",
    "data-name": "Ellipse 17",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5500 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-64",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5520 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-64",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5540 1487)",
    fill: "#9060f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-64",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(5560 1487)",
    fill: "#9060f2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(332 6562)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 628,
    r: 628,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 628,
    r: 627.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    transform: "translate(293 6523)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 667,
    cy: 667,
    r: 667,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667,
    cy: 667,
    r: 666.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    transform: "translate(247 6477)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 713,
    cy: 713,
    r: 713,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 713,
    cy: 713,
    r: 712.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeambg);
export default __webpack_public_path__ + "static/media/teambg.8e75fd516a0b84899a478b256aa6e3ec.svg";
export { ForwardRef as ReactComponent };